"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedAlgoliaViewAllLink = void 0;
const react_1 = __importDefault(require("react"));
const template_1 = __importDefault(require("lodash-es/template"));
const react_instantsearch_core_1 = require("react-instantsearch-core");
const AlgoliaViewAllLink = (props) => {
    const { nbHits, href, viewAllLinkText, limit } = props;
    if (!viewAllLinkText) {
        return (react_1.default.createElement("a", { href: href, className: "btn btn-link" }, "View All"));
    }
    let text = (0, template_1.default)(viewAllLinkText.default);
    if (nbHits > limit) {
        text = (0, template_1.default)(viewAllLinkText.many);
    }
    return (react_1.default.createElement("a", { href: href, className: 'btn btn-link' }, text({ count: nbHits }) || 'View All'));
};
exports.ConnectedAlgoliaViewAllLink = (0, react_instantsearch_core_1.connectStats)(AlgoliaViewAllLink);
